import {RELATIONS} from "./constants.js";

export const Join = function(leftAttributeRelation, rightAttributeRelation) {
    // The left is always the one to which the field is being set.

    this.left = leftAttributeRelation;
    this.right = rightAttributeRelation;

    this.getLookup = (models, attributeRelation) => {
        return models.reduce((lookup, model) => {
            const value = attributeRelation.attribute.getFrom(model);
            /*
            There are basically 8 possible combos, 4 relations and 2 possible meta relations for 2 objects

            - ManyToMany - Left Many
            - ManyToMany - Right Many
            - OneToMany - Left One
            - OneToMany - Right Many
            - ManyToOne - Left Many
            - ManyToOne - Right One
            - OneToOne - Left One
            - OneToOne - Right One
            */
            if(attributeRelation.relation === RELATIONS["One"]) {
                lookup[value] = model;
            } else if(attributeRelation.relation === RELATIONS["Many"]) {
                if(!Object.prototype.hasOwnProperty.call(lookup, value)) {
                    lookup[value] = [model];
                } else {
                    lookup[value].push(model);
                }
            }
            return lookup;
        }, {});
    };

    this.join = (leftModels, rightModels) => {
        const rightLookup = this.getLookup(rightModels, this.right);
        const leftLookup = this.getLookup(leftModels, this.left);

        leftModels.map(leftModel => {
            if(!Object.prototype.hasOwnProperty.call(leftModel, this.left.foreignAttribute.name)) {
                const leftLookupKey = this.left.attribute.getFrom(leftModel);
                const rightModel = rightLookup[leftLookupKey];
                leftModel[this.left.foreignAttribute.name] = rightModel;
            }
            return leftModel;
        });

        rightModels.map(rightModel => {
            rightModel[this.right.foreignAttribute.name] =
                leftLookup[this.right.attribute.getFrom(rightModel)];
        });
    };
};
